import React, { Component } from 'react';
import ReproduceInvoiceModal from './ReproduceInvoiceModal';
import UpdateInvoiceModal from './UpdateInvoiceModal';

class InvoiceList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showReproduceInvoiceModalInvoice: false,
            showUpdateInvoiceModalInvoice: false,
        };
    }

    showReproduceInvoiceModal = (_, invoice) => {
        this.setState({
            showReproduceInvoiceModalInvoice: invoice,
        });
    };

    hideReproduceInvoiceModal = () => {
        this.setState({
            showReproduceInvoiceModalInvoice: false,
        });
    };

    showUpdateInvoiceModal = (_, invoice) => {
        this.setState({
            showUpdateInvoiceModalInvoice: invoice,
        });
    };

    hideUpdateInvoiceModal = () => {
        this.setState({
            showUpdateInvoiceModalInvoice: false,
        });
    };

    render() {
        let invoices = this.props.data.map((invoice, index) => {
            return (
                <tr key={index}>
                    <td>{invoice.id}</td>
                    <td>{this.props.providerInvoice ? invoice.invoiceable.name : invoice.invoiceable.customer.name}</td>
                    <td className={invoice.reviewed ? '' : 'text-danger'}>{invoice.reviewed ? 'Yes' : 'No'}</td>
                    <td className={invoice.sent ? '' : 'text-danger'}>{invoice.sent ? 'Yes' : 'No'}</td>
                    <td>{moment(invoice.created_at).format('DD/MM/YYYY')}</td>
                    <td>
                        <a
                            href={this.props.downloadUrl
                                .replace(
                                    'customer:id',
                                    this.props.providerInvoice
                                        ? invoice.invoiceable.id
                                        : invoice.invoiceable.customer.id
                                )
                                .replace('invoice:id', invoice.id)}
                            className="d-block"
                        >
                            {invoice.name}
                        </a>
                    </td>
                    <td>
                        <div className="d-flex">
                            <input
                                type="text"
                                value={invoice.po_number || ''}
                                onChange={(e) => this.props.onPoChange(e, invoice.invoice_identifier)}
                                className="form-control"
                            />
                            <button
                                className="btn btn-cw-primary"
                                onClick={() => this.props.savePoNumber(invoice.invoice_identifier)}
                            >
                                {this.props.loading === invoice.invoice_identifier ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    'Save'
                                )}
                            </button>
                        </div>
                    </td>
                    <td>
                        <a
                            href={this.props.invoiceUrl?.replace('actionOrId', invoice.id)}
                            className="text-info"
                            title="View Invoice"
                        >
                            <i className="fas fa-eye mr-1"> </i>
                        </a>
                        <button
                            style={{
                                padding: 0,
                                marginBottom: 0,
                                marginRight: '4px',
                                border: 0,
                            }}
                            onClick={(e) => this.showReproduceInvoiceModal(e, invoice)}
                            className="btn btn-link text-danger"
                            title="Reproduce Invoice"
                        >
                            <i className="fas fa-recycle mr-12"></i>
                        </button>
                    </td>
                </tr>
            );
        });
        return (
            <>
                <table className="table transform-text">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>{this.props.providerInvoice ? 'Service provider name' : 'Customer name'}</th>
                            <th>Reviewed</th>
                            <th>Sent</th>
                            <th>Created</th>
                            <th>Download</th>
                            <th>PO number</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>{invoices}</tbody>
                </table>
                {this.state.showReproduceInvoiceModalInvoice && (
                    <ReproduceInvoiceModal
                        show={true}
                        onHide={this.hideReproduceInvoiceModal}
                        invoice={this.state.showReproduceInvoiceModalInvoice}
                    />
                )}
                {this.state.showUpdateInvoiceModalInvoice && (
                    <UpdateInvoiceModal
                        show={true}
                        onHide={this.hideUpdateInvoiceModal}
                        invoice={this.state.showUpdateInvoiceModalInvoice}
                    />
                )}
            </>
        );
    }
}

export default InvoiceList;
